import { useMemo } from "react";

import { AuthContext } from "@/data/auth/auth.context";
import type { ProfileModels } from "@/data/profile/profile.models";
import { ProfileUtils } from "@/util/profile.utils";

interface UseUserExperienceOptions {
  userProfile?: ProfileModels.FullProfileResponseDto | null;
}

interface UseUserExperienceReturn {
  yearsOfExperience: number;
}

export const useUserExperience = (options?: UseUserExperienceOptions): UseUserExperienceReturn => {
  const { user } = AuthContext.useAuth();
  const userProfile = options?.userProfile ?? user;

  const yearsOfExperience = useMemo(() => {
    return ProfileUtils.calculateYearsOfExperience(userProfile?.dataV02);
  }, [userProfile?.dataV02]);

  return {
    yearsOfExperience,
  };
};
